"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fileIdCreator_1 = __importDefault(require("../helper/fileIdCreator"));
const fileNameFormatter_1 = __importDefault(require("../helper/fileNameFormatter"));
const fileSizeFormatter_1 = __importDefault(require("../helper/fileSizeFormatter"));
const filePreviewCardRenderer_1 = __importDefault(require("./filePreviewCardRenderer"));
const filePreviewListRenderer_1 = __importDefault(require("./filePreviewListRenderer"));
const previewCreator_1 = __importDefault(require("./previewCreator"));
class FilePreviewFactory {
    static createFilePreviewRenderer(controller, fileInput, listArea, previewTemplate) {
        const params = [
            listArea,
            previewTemplate,
            controller,
            new fileNameFormatter_1.default(),
            new fileSizeFormatter_1.default(),
            new fileIdCreator_1.default()
        ];
        if (!!fileInput.dataset.jsFilePreview) {
            return new filePreviewCardRenderer_1.default(...params, new previewCreator_1.default());
        }
        return new filePreviewListRenderer_1.default(...params);
    }
}
exports.default = FilePreviewFactory;
